import React from 'react';
import ReactDOM from 'react-dom/client';
import { AboutPage } from './AboutPage';
import '~/styles/main.scss';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <AboutPage />
  </React.StrictMode>
);
